
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import lineCharts from "./components/line-charts.vue"
  import timestatistical from "./components/timestatistical.vue"
  import {
    dataStatisdataStatisSingleMembeTeamSevenData,
    dataStatisdataStatisSingleMembeTeamSingleProductAnalysis,
    dataStatisdataStatisSingleMembeTeamProductCategoryAnalysis
  } from "@/api/material"
  import {
    productCategory,
  } from '@/api/supplier'
	import {
    getSearchDate,
		nextDay
	} from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      lineCharts,
      timestatistical
    }
  })

  export default class ProductList extends Vue {
    private type1 = 1;
    private time1:any = []
    private lineloading = false
    private linedata:any = []
    private lines1:any = []
    private linedata2:any = []
    private lines2:any = []

    private keywords1 = ''
    private tablelist1:any = []
    private tableloading1 = false
    private currentPage1 = 1
    private pagesize1 = 10
    private total1 = 0
    private defaultsort = {
      prop:'SellProductCount',
      order:'descending'
    }
    private keywords2 = ''
    private tablelist2:any = []
    private tableloading2 = false
    private currentPage2 = 1
    private pagesize2 = 10
    private total2 = 0
    private defaultsort2 = {
      prop:'SellProductCount',
      order:'descending'
    }

    private mounted () {
      let time = String(this.$route.query.time)
      this.time1 = time.split('/')
      this.type1 = Number(this.$route.query.type)
      // console.log(this.time1)
      this.getlineCharts()
      this.gettablelist1()
      this.gettablelist2()
    }


    private exportFile(type){
      let url = location.origin
      if(type==1){
        url += '/pc/dataStatis/dataStatisSingleMembeTeamSingleProductAnalysisExport'
        url += '?MemberId=' + this.$route.query.Id
        url += '&Keywords=' + encodeURI(this.keywords1)
        url += '&StartDate=' + this.time1[0]
        url += '&EndDate=' + this.time1[1]
        url += '&OrderBy=' + (this.defaultsort.prop==null?'SellProductCount':this.defaultsort.prop)
        url += '&IsAsc=' + (this.defaultsort.order=='ascending'?true:false)
      }else{
        url += '/pc/dataStatis/dataStatisSingleMembeTeamProductCategoryAnalysisExport'
        url += '?MemberId=' + this.$route.query.Id
        url += '&Keywords=' + encodeURI(this.keywords2)
        url += '&StartDate=' + this.time1[0]
        url += '&EndDate=' + this.time1[1]
        url += '&OrderBy=' + (this.defaultsort2.prop==null?'SellProductCount':this.defaultsort2.prop)
        url += '&IsAsc=' + (this.defaultsort2.order=='ascending'?true:false)
      }
      window.open(url)
    }
    private async getlineCharts(){
      try{
        this.lineloading = true
        this.linedata = []
        this.linedata2 = []
        let data = {
          MemberId:this.$route.query.Id
        }
        let res = await dataStatisdataStatisSingleMembeTeamSevenData(data)
        if(res.IsSuccess){
          this.linedata = res.Result.map(v=>{
            v.Date = v.Time
            return v
          })
          this.lines1 = [
            {key:'OrderGroupPrice',name:'订单金额',},
            {key:'OrderCount',name:'订单数量'},
          ]

          
          this.linedata2 = res.Result.map(v=>{
            v.Date = v.Time
            return v
          })
          this.lines2 = [
            {key:'AddTwoRoleMemberCount',name:'新增VIC人数'},
            {key:'AddThirdRoleMemberCount',name:'新增VIP数量'},
            {key:'SubmitOrderCustomerCount',name:'新增客户数量'},
          ]

          // console.log(this.linedata,this.linedata2)
        }
      }finally{
        this.lineloading = false
      }
    }
    private gettime(e,num){
      let type = 'type' + num
      let time = 'time' + num
      this[type] = e.type
      this[time] = e.time
      this.currentPage1 = 1
      this.currentPage2 = 1
      this.gettablelist1()
      this.gettablelist2()
    }
    private doSearch(num){
      if(num==1){
        this.currentPage1 = 1
        this.gettablelist1()
      }else if(num==2){
        this.currentPage2 = 1
        this.gettablelist2()
      }
    }
    private clearSearch(num){
      if(num==1){
        this.keywords1 = ''
        this.currentPage1 = 1
        this.gettablelist1()
      }else if(num==2){
        this.keywords2 = ''
        this.currentPage2 = 1
        this.gettablelist2()
      }
    }
    private sortmethod(col){
      this.defaultsort = {
        prop:col.prop,
        order:col.order
      }
      this.gettablelist1()
    }
    private sortmethod2(col){
      this.defaultsort2 = {
        prop:col.prop,
        order:col.order
      }
      this.gettablelist2()
    }
    private async gettablelist1(){
      try{
        this.tableloading1 = true
        let data:any = {
          MemberId:this.$route.query.Id,
          Keywords:this.keywords1,
          StartDate:this.time1[0],
          EndDate:this.time1[1],
          OrderBy:this.defaultsort.prop,
          IsAsc:this.defaultsort.order=='ascending'?true:false,
          Skip:(this.currentPage1-1)*this.pagesize1,
          Take:this.pagesize1,
        }
        if(this.defaultsort.order == null){
          data.OrderBy = 'SellProductCount'
        }
        // console.log(this.defaultsort.order == null,data.OrderBy)
        let res = await dataStatisdataStatisSingleMembeTeamSingleProductAnalysis(data)
        if(res.IsSuccess){
          this.tablelist1 = res.Result.Results.map((v,i)=>{
            v.number = i+1+(this.currentPage1-1)*this.pagesize1
            return v
          })
          this.total1 = res.Result.Total
        }
      }finally{
        this.tableloading1 = false
      }
    }
    private handleSizeChange1(e){
      this.currentPage1 = 1
      this.pagesize1 = e
      this.gettablelist1()
    }
    private handleCurrentChange1(e){
      this.currentPage1 = e
      this.gettablelist1()
    }
    private headercell(){
      return 'headercellstyle'
    }
    private async gettablelist2(){
      try{
        this.tableloading2 = true
        let data:any = {
          MemberId:this.$route.query.Id,
          Keywords:this.keywords2,
          StartDate:this.time1[0],
          EndDate:this.time1[1],
          OrderBy:this.defaultsort2.prop,
          IsAsc:this.defaultsort2.order=='ascending'?true:false,
          Skip:(this.currentPage2-1)*this.pagesize2,
          Take:this.pagesize2,
        }
        if(this.defaultsort2.order == null){
          data.OrderBy = 'SellProductCount'
        }
        let res = await dataStatisdataStatisSingleMembeTeamProductCategoryAnalysis(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results.map((v,i)=>{
            v.number = i+1+(this.currentPage2-1)*this.pagesize2
            return v
          })
          this.total2 = res.Result.Total
        }
      }finally{
        this.tableloading2 = false
      }
    }
    private handleSizeChange2(e){
      this.currentPage2 = 1
      this.pagesize2 = e
      this.gettablelist2()
    }
    private handleCurrentChange2(e){
      this.currentPage2 = e
      this.gettablelist2()
    }
  }

